import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import '../../Foundations/PhotoOverlay/PhotoOverlay.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './Link.module.css.mjs';
import { linkSizeText } from './Link.utils.mjs';

const Link = polymorphicFactory(
  (props, ref) => {
    const { component = "a", children, size = "medium", underline = true, className, leftIcon, rightIcon, ...rest } = props;
    const classNames = clsx(classes.root, "kohler-text-link-root", className, underline && classes.linkUnderline);
    return /* @__PURE__ */ React.createElement(Typography, { className: classNames, component, ref, ...rest, size: linkSizeText[size] }, leftIcon && /* @__PURE__ */ React.createElement(Box, { component: "span", className: clsx("kohler-text-link-icon", classes.icons) }, leftIcon), /* @__PURE__ */ React.createElement(Box, { component: "span" }, children), rightIcon && /* @__PURE__ */ React.createElement(Box, { component: "span", className: clsx("kohler-text-link-icon", classes.icons) }, rightIcon));
  }
);

export { Link };
